export default {
    URL_API: 'https://api.soundanalytics.cl/v2.0'
}
